import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/flows/new')({});
